import ParallaxImage from "../../modules/ParallaxImage";

export function initParallaxImages(parallaxImages) {
	parallaxImages.forEach((parallaxImage) => {
		
	});
}
